import { render, staticRenderFns } from "./xunzheng.vue?vue&type=template&id=0fe95b1e&scoped=true&"
import script from "./xunzheng.vue?vue&type=script&lang=ts&"
export * from "./xunzheng.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe95b1e",
  null
  
)

export default component.exports